<template>
  <div>
    <vs-sidebar position-right parent="body" default-index="1" class="sidebarx" v-model="active">
      <div class="content with--background">
        <section class="section--sidebar-user">
          <section class="section--title-sidebar">
              <h3>Nuovo</h3>
          </section>
          <section class="section--content-sidebar section--content-sidebar-full-height">
            <form method="POST" :action="this.action" accept-charset="UTF-8" enctype="multipart/form-data">
              <div class="form-group">
                <label for="person_id" class="">{{__('forms.EvaluationChart.assessed_person')}}</label>
                <multiselect required="true" v-model="selectedPerson" @input="getRolesPerson" :options="people" placeholder="Select one" label="identifiable_name" track-by="identifiable_name"></multiselect>
              </div>
              <div class="form-group">
                <label for="role_person_id" class="font-weight-bold">
                    {{__('forms.EvaluationChart.active_roles')}}
                </label>
                <div v-if="axiosRoles.length == 0">
                  <div class="alert alert-warning" role="alert">
                    <label>{{__("forms.EvaluationChart.noRoles")}}</label>
                  </div>
                </div>
                <div class="row" v-for="role in axiosRoles">
                  <div class="col-1">
                    <input type="radio" name="evaluation_chart[role_id]" :value="role.id" v-model="selectedRole" @change="getDerivativeRoleInfo($event)">
                  </div>
                    <div class="col-5">
                      <label>{{role.name}}</label>
                    </div>
                    <div class="col-3">
                      <label>{{role.start_date}}</label>
                    </div>
                    <div class="col-3">
                      <label>{{role.end_date}}</label>
                    </div>
                </div>
              </div>
              <div class="form-group" v-if="maxCoverageRole != null">
                <label for="role_person_id" class="font-weight-bold">
                    {{__('forms.EvaluationChart.role_max_coverage')}}
                </label>
                <div class="row">
                  <div class="col-1">
                    <input type="radio" name="evaluation_chart[role_id]" :value="maxCoverageRole.id" v-model="selectedRole" @change="getDerivativeRoleInfo($event)">
                  </div>
                  <div class="col-5">
                    <label>{{maxCoverageRole.name}}</label>
                  </div>
                  <div class="col-3">
                    <label>{{maxCoverageRole.start_date}}</label>
                  </div>
                  <div class="col-3">
                    <label>{{maxCoverageRole.end_date}}</label>
                  </div>
                </div>
              </div>
              <div class="form-group" v-if="otherCoveredRoles.length > 0" >
                <label for="role_person_id" class="font-weight-bold">
                    {{__('forms.EvaluationChart.roles_covered_in_evaluation_time')}}
                </label>
                <div class="row" v-for="role in otherCoveredRoles">
                  <div class="col-1">
                    <input type="radio" name="evaluation_chart[role_id]" :value="role.id" v-model="selectedRole" @change="getDerivativeRoleInfo($event)">
                  </div>
                  <div class="col-5">
                    <label>{{role.name}}</label>
                  </div>
                  <div class="col-3">
                    <label>{{role.start_date}}</label>
                  </div>
                  <div class="col-3">
                    <label>{{role.end_date}}</label>
                  </div>
                </div>

              </div>

              <div v-if="survey_has_multilevel" class="form-group">
                <label>{{__('forms.levelFactorsGroup.LevelFactorGroup')}}</label>
                <select v-model="multilevelGroup" required name="evaluation_chart[multilevel_group_id]" class="form-control">
                  <option v-for="group in axiosMultilevelGroups" :value="group.id">{{group.name}}</option>
                </select>
              </div>
              <div v-if="survey_has_pnp" class="form-group">
                <label>{{ __("forms.EvaluationChart.baseChart")}}</label>
                <select v-if="axiosBaseCharts.length > 0" v-model="selectedBaseChart" required name="evaluation_chart[base_chart_id]" class="form-control">
                  <option v-for="baseChart in axiosBaseCharts" :key="baseChart.id" :value="baseChart.id">{{baseChart.name}}</option>
                </select>
                <div v-else class="alert alert-warning" role="alert">
                  <label>{{__("forms.EvaluationChart.noBaseChart")}}</label>
                </div>
              </div>
              <div v-if="survey_has_behaviours" class="form-group">
                <input type="hidden" name="behaviourSet[behaviors_set_id]" v-model="axiosBehaviorSet" >
<!--                <label>{{__('forms.behaviors.set')}}</label>-->
<!--                <select required name="behaviourSet[behaviors_set_id]" v-model="axiosBehaviorSet" class="form-control">-->
<!--                  <option v-for="behaviorSet in behaviors_set" :value="behaviorSet.id">{{behaviorSet.name}}</option>-->
<!--                </select>-->
              </div>

              <div class="form-group">
                  <label>{{__('forms.EvaluationChart.evaluationType')}}</label>
                  <select name="evaluation_chart[evaluation_type]" class="form-control">
                      <option value="">---</option>
                      <option value="top_down">Top Down</option>
                      <option value="bottom_up">Bottom Up</option>
                      <option value="peer">Peer</option>
                      <option value="self">Autovalutazione</option>
                  </select>
              </div>
              <input type="hidden" name="_token" :value="csrf">
              <input v-if="this.editing" type="hidden" name="_method" value="PUT">
              <input type="hidden" name="evaluation_chart[evaluation_session_id]" :value="evaluation.id">
              <input type="hidden" name="evaluation_roles[assessed_person_id]" :value="selectedPerson.id">
              <div v-if="selectedPerson.id != null">
                <div v-if="survey_has_behaviours && axiosBehaviorSet == null">
                    <label>{{__("forms.EvaluationChart.noBehaviorSet")}}</label>
                </div>
                <div v-if="survey_has_pnp && axiosBaseCharts.length == 0">
                    <label>{{__("forms.EvaluationChart.noBaseChart")}}</label>
                </div>
                <div v-if="!survey_has_pnp && axiosRoles.length == 0">
                </div>
                <div v-else class="form-buttons clear">
                  <button :disabled="!this.hasRoleSelected" type="submit" class="btn btn--green">{{ __('misc.update') }} </button>
                </div>
              </div>
            </form>
          </section>
        </section>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>

  export default {
    data () {
      return {
        value: null,
        multilevelGroup : null,
        editing: false,
        active: false,
        alertBehavioursNull : true,
        action: "",
        title: "",
        parameters: {},
        csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
        selectedPerson: {},
        selectedRole: {},
        axiosRoles : {},
        otherCoveredRoles : {},
        maxCoverageRole : null,
        axiosMultilevelGroups : {},
        axiosBehaviorSet : null,
        axiosBaseCharts : [],
        selectedBaseChart : null,
        hasRoleSelected: false
      }
    },
    watch: {
      selectedPerson() {
        this.hasRoleSelected = false;
      },
      selectedRole() {
        this.hasRoleSelected = true;
      }
    },
    methods: {

        getRolesPerson(){

            axios.post("/evaluations-charts/get-roles-evaluated",{
              "newChart" :{
                "person_id" : this.selectedPerson.id,
                "evaluation_session_id" : this.evaluation.id
              }
            }) .then(response => {
                this.axiosRoles = response.data.roles;
                this.maxCoverageRole = response.data.maxCoverageRole;
                this.otherCoveredRoles = response.data.otherCoveredRoles;

                this.axiosBaseCharts = [];
                this.selectedBaseChart = null;

            });


        },
        getDerivativeRoleInfo(event){

          let role_id = event.target.value;
          axios.post("/evaluations-charts/get-role-associated-data-for-evaluated/"+role_id+"/role",{})
            .then(response => {
                this.axiosMultilevelGroups = response.data.multilevelGroups;
                this.axiosBehaviorSet = response.data.behaviorSet;
                this.axiosBaseCharts = response.data.baseCharts;
                this.selectedBaseChart = this.axiosBaseCharts.length > 0 ? this.axiosBaseCharts[0].id : null;
          });
        },

        toggle(action, item_id, editing, attributes) {

            this.active = true;
            this.action = action;
            this.editing = editing;

        }
    },
    mounted() {
    },
    props: {
      evaluation: {
        type: Object,
        required: true
      },
      people: {
        type: Array,
        required: true
      },
      survey_has_pnp: {
        type: Boolean,
        required: true
      },
      survey_has_multilevel: {
        type: Boolean,
        required: true
      },
      survey_has_behaviours: {
        type: Boolean,
        required: true
      },
      roles: {
        type: Array,
        required: true
      }
    }

  }
</script>


<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
